'use strict';
// TODO: requires googlemaps/v3-utility-library/markerclusterer/src/markerclusterer.js

import {getId} from '../../core-utilities/domain/ReduxUtils';
import {getProject} from '../../app/model/reducers/state';


ProjectAssetMapClusterFactory.$inject = [
  '$ngRedux',
  'ProjectDomain',
  'AssetDomain',
];

export function ProjectAssetMapClusterFactory(
  $ngRedux,
  ProjectDomain,
  AssetDomain,
) {
  function ProjectAssetMapCluster($scope) {
    Object.defineProperty(this, '__scope', {configurable: true, value: $scope});
  }

  ProjectAssetMapCluster.prototype.init = init;
  ProjectAssetMapCluster.prototype.getPositions = getPositions;
  ProjectAssetMapCluster.prototype.addMarkers = addMarkers;
  ProjectAssetMapCluster.prototype.cleanup = cleanup;

  function init(mapManager) {
    this.mapManager = mapManager;
  }

  // resolves to true if there are positions, false otherwise
  function getPositions() {
    const rootState = $ngRedux.getState();
    const project = getProject(rootState);
    if (!project) return;

    const projectId = getId(project);
    return ProjectDomain.$getAllAssetProjectsRelations(projectId).then(function (relations) {
      const promises = [];

      for (let key in relations) {
        if (relations.hasOwnProperty(key)) {
          const id = ProjectDomain.deconstructAssetId(projectId, key);
          if (id) {
            promises.push(AssetDomain.$get(id).then(_getPosition));
          }
        }
      }

      return Promise.all(promises);
    }).then(_filterPositions.bind(this));
  }

  function addMarkers() {
    if (!this.positions || !this.positions.length) return;
    this.dynMarkers = [];
    const bounds = new this.mapManager.mapApi.LatLngBounds();
    for (let i = 0, length = this.positions.length; i < length; i++) {
      const latLng = new this.mapManager.mapApi.LatLng(this.positions[i][0], this.positions[i][1]);
      this.dynMarkers.push(new this.mapManager.mapApi.Marker({position: latLng}));
      bounds.extend(this.dynMarkers[i].position);
    }
    this.markerClusterer = new MarkerClusterer(this.mapManager.map, this.dynMarkers, {});
    this.mapManager.map.setCenter(bounds.getCenter());
    this.mapManager.map.fitBounds(bounds);
  }

  function cleanup() {
    // TODO: figure out how to properly dispose of the MarkerClusterer
  }

  function _getPosition(asset) {
    if (asset && asset.geo && asset.geo.geometry && asset.geo.geometry.coordinates && asset.geo.geometry.coordinates) {
      return asset.geo.geometry.coordinates;
    } else {
      return null;
    }
  }

  function _filterPositions(positions) {
    this.positions = [];
    for (let i = 0, length = positions.length; i < length; i++) {
      if (positions[i]) this.positions.push(positions[i]);
    }
    return this.positions.length > 0;
  }

  return ProjectAssetMapCluster;
}



// WEBPACK FOOTER //
// ./src/js/projects/services/ProjectAssetMapClusterFactory.js